<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Attachment - {{ticket.id}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-file-input
          accept="image/png, image/jpeg"
          label="attachment"
          outlined
          show-size
          @change="selectFile"
          ref="fileUpload"
          :disabled="uploading"
        ></v-file-input>
        <v-text-field
          label="description"
          placeholder="description"
          v-model="description"
          outlined
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="amber" @click="onUploadClick()" :disabled="currentFile === null || description.length === 0" :loading="uploading">Upload</v-btn>
        <v-btn color="grey lighten-1" :disabled="uploading" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  components: {
  },

  props: {
    dialog: Boolean,
    ticket: Object,
  },

  data() {
    return {
      currentFile: null,
      uploading: false,
      description: '',
    };
  },

  methods: {
    onUploadClick() {
      this.uploading = true;

      if (this.currentFile) {
        const formData = new FormData();
        formData.append('file', this.currentFile);
        formData.append('description', this.description);

        this.axios.post(`/upload_ticket_attachment?ticketId=${this.ticket.id}&authorUsername=${this.$store.state.auth.token.user.username}`, formData)
          .then((res) => {
            this.uploading = false;
            this.currentFile = null;
            this.description = '';
            this.$refs.fileUpload.reset();

            console.log(`--> new attachment: ${JSON.stringify(res.data)}`);

            this.ticket.attachments.unshift(res.data);

            this.$emit('close', { });
          });
      }
    },

    onCancelClick() {
      this.uploading = false;
      this.currentFile = null;
      this.description = '';
      this.$refs.fileUpload.reset();
      this.$emit('close', { });
    },

    selectFile(file) {
      this.currentFile = file;
    },
  },
};
</script>
